<template>
  <div class="slide-up-alert" :style="{ display: visible ? 'block' : 'none' }">
    <div class="alert-content" :class="{ 'slide-in': visible }">
      <div class="alert-header">
        <span class="alert-title">{{ title }}</span>
        <i class="el-icon-close" @click="close"></i>
      </div>
      <div class="alert-body" v-html="content"></div>
      <div class="alert-footer">
        <el-button type="primary" @click="close">我知道了</el-button>
      </div>
    </div>
    <div
      class="alert-mask"
      @click="close"
      :style="{ display: visible ? 'block' : 'none' }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "SlideUpAlert",
  props: {
    title: {
      type: String,
      default: "提示",
    },
    content: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: Number,
      default: 2000, // 默认2秒后显示
    },
  },
  data() {
    return {
      visible: false,
      timer: null,
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.delayShow();
      } else {
        this.close();
      }
    },
  },
  mounted() {
    if (this.show) {
      this.delayShow();
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    delayShow() {
      this.timer = setTimeout(() => {
        this.visible = true;
      }, this.duration);
    },
    close() {
      this.visible = false;
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.slide-up-alert {
  position: fixed;
  bottom: 100px;
  left: 30%;
  z-index: 9999;
  width: 40%;
}

.alert-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
}

.alert-content {
  position: relative;
  z-index: 9999;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  bottom: 100px;
  /* bottom: 0; */
  /* transform: translateY(0); 
  transition: transform 0.3s ease-out; */
}

.slide-in {
  /* transform: translateY(-200px); 滑动到可见位置 */
  animation: window-open 1s 1;
}

.alert-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.alert-title {
  font-size: 24px;
  font-weight: bold;
  color: #ff0000;
}

.alert-body {
  min-height: 100px;
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.6;
}

.alert-footer {
  text-align: center;
}
@keyframes window-open {
  0% {
    bottom: -5.5rem;
  }
  100% {
    bottom: 100px;
  }
}
</style>
